import * as React from 'react'
import { SVGComponentProps } from '../type'

const PercentageCircleIcon = (props: SVGComponentProps) => (
  <svg
    width={props.width}
    height={props.height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.568 16.02C8.378 16.02 8.188 15.95 8.038 15.8C7.748 15.51 7.748 15.03 8.038 14.74L14.588 8.19C14.878 7.9 15.358 7.9 15.648 8.19C15.938 8.48 15.938 8.96 15.648 9.25L9.098 15.8C8.948 15.95 8.758 16.02 8.568 16.02Z"
      fill={props.fill}
    />
    <path
      d="M8.98 11.11C7.89 11.11 7 10.22 7 9.13C7 8.04 7.89 7.15 8.98 7.15C10.07 7.15 10.96 8.04 10.96 9.13C10.96 10.22 10.07 11.11 8.98 11.11ZM8.98 8.66C8.72 8.66 8.5 8.87 8.5 9.14C8.5 9.41 8.71 9.62 8.98 9.62C9.25 9.62 9.46 9.41 9.46 9.14C9.46 8.87 9.24 8.66 8.98 8.66Z"
      fill={props.fill}
    />
    <path
      d="M15.519 16.84C14.429 16.84 13.539 15.95 13.539 14.86C13.539 13.77 14.429 12.88 15.519 12.88C16.609 12.88 17.499 13.77 17.499 14.86C17.499 15.95 16.609 16.84 15.519 16.84ZM15.519 14.39C15.259 14.39 15.039 14.6 15.039 14.87C15.039 15.14 15.249 15.35 15.519 15.35C15.789 15.35 15.999 15.14 15.999 14.87C15.999 14.6 15.789 14.39 15.519 14.39Z"
      fill={props.fill}
    />
    <path
      d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z"
      fill={props.fill}
    />
  </svg>
)

PercentageCircleIcon.defaultProps = {
  width: 24,
  height: 24,
  fill: '#64748B'
}

export { PercentageCircleIcon }
